// extracted by mini-css-extract-plugin
export default {"info":"Body_info__3urmE","proj":"Body_proj__WpkuK"};